export const getRequestId = (response) => {
  const requestIdFromBody = response?.data?.requestId;
  const requestIdFromHeaders = response?.headers?.get?.("x-request-id");

  return requestIdFromBody ?? requestIdFromHeaders ?? "";
};
